// Versi butir Survei Kepuasan (PR #107, baca-saja) -- fungsi murni tab "Butir" & form periode (diuji surveiVersi.test.js).
// Isi versi selalu dari server (GET /survei/versi-butir[/{id}]); PR #108 menambah mode edit di atas fungsi ini.

export const STATUS_DRAF = "draf";
export const LABEL_STATUS_VERSI = { draf: "Draf", terkunci: "Terkunci" };

// Cermin survei_versi.versi_bawaan: versi NON-draf bernomor tertinggi (null bila tidak ada).
export function versiBawaan(daftar) {
    const calon = (daftar || []).filter((v) => v.status !== STATUS_DRAF);
    return calon.reduce((a, v) => (!a || v.nomor_versi > a.nomor_versi ? v : a), null);
}

// Versi yg boleh dipilih periode baru (non-draf), terbaru dulu.
export const versiBolehDipilih = (daftar) =>
    (daftar || []).filter((v) => v.status !== STATUS_DRAF).sort((a, b) => b.nomor_versi - a.nomor_versi);

export const teksDipakai = (n) => (n ? `${n} periode` : "Belum dipakai");

// Baris tabel isi versi: butir urut nomor + nama dimensinya.
export function barisButir(versi) {
    const nama = Object.fromEntries((versi?.dimensi || []).map((d) => [d.kode, d.nama]));
    return [...(versi?.butir || [])]
        .sort((a, b) => a.nomor - b.nomor)
        .map((b) => ({ ...b, nama_dimensi: nama[b.dimensi_kode] || b.dimensi_kode }));
}

// Ringkasan per dimensi (urut `urutan`): kode, nama, jumlah butir.
export function ringkasDimensi(versi) {
    const butir = versi?.butir || [];
    return [...(versi?.dimensi || [])]
        .sort((a, b) => a.urutan - b.urutan)
        .map((d) => ({ kode: d.kode, nama: d.nama, jumlah: butir.filter((b) => b.dimensi_kode === d.kode).length }));
}
